export const SHOW_CLONE_SETTINGS_MODAL = "SHOW_CLONE_SETTINGS_MODAL";
export const SHOW_CLONE_SETTINGS_MODAL_HIDE = "SHOW_CLONE_SETTINGS_MODAL_HIDE";

